import React from 'react';
import { Search, Users, Sparkles } from 'lucide-react';
import './TeamHeader.css';

interface TeamHeaderProps {
  memberCount: number;
  maxMembers: number;
  search: string;
  showUpgradeBtn: boolean;
  onSearchChange: (v: string) => void;
  onInvite: () => void;
  onUpgrade: () => void;
  onUpgradeClick?: () => void;
}

export function TeamHeader({
  memberCount,
  maxMembers,
  search,
  showUpgradeBtn,
  onSearchChange,
  onInvite,
  onUpgrade,
  onUpgradeClick,
}: TeamHeaderProps) {
  return (
    <div className="team-toolbar">
      {/* Search */}
      <div className="team-toolbar__search">
        <Search size={13} className="team-toolbar__search-icon" />
        <input
          className="team-toolbar__search-input"
          placeholder="Search members…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      {/* Right side */}
      <div className="team-toolbar__actions">

        {showUpgradeBtn && (
          <button className="team-toolbar__upgrade-btn" onClick={onUpgradeClick || onUpgrade}>
            <Sparkles size={13} />
            Upgrade Plan
          </button>
        )}

        <button id="tour-invite-member" className="team-toolbar__invite-btn" onClick={onInvite}>
          <Users size={14} />
          Invite Member
        </button>
      </div>
    </div>
  );
}
